export const BUDGET_DEFAULT = 550000;
export const BUDGET_DEFAULT = 550000;
